import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFile from '../Shared/ChunkedUploadFile';
import './SpaceUpOneUploadFile.css';

const SPACE_UP_ONE_ROOT =
  process.env.REACT_APP_SPACEUPONE_BASE || '/spaceup-one';

function SpaceUpOneUploadFile({ currentPath, userId, onFileUploaded }) {
  return (
    <ChunkedUploadFile
      currentPath={currentPath}
      userId={userId}
      onFileUploaded={onFileUploaded}
      rootPath={SPACE_UP_ONE_ROOT}
      sessionPrefix="space_up_one_file"
    />
  );
}

SpaceUpOneUploadFile.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFileUploaded: PropTypes.func,
};

export default SpaceUpOneUploadFile;
